// Core
import React, { useState, useEffect } from 'react';
import { Text, useColorModeValue, useColorMode} from '@chakra-ui/react';

// Assets
import { countdownTimer } from 'services/Utils';
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import { ReactComponent as LinesWhite } from 'assets/svg/lines-white.svg';

const Countdown = ({ endDate, declareDate, position, width, top, bottom, right, fontSize, p, m, borderWidth, isLine }) => {
    const [timeLeft, setTimeLeft] = useState('');

    const colorDate = useColorModeValue('white', '#0E1633');
    const { colorMode } = useColorMode();
    const isDark = colorMode === 'dark';

    useEffect(() => {
        const stopTimer = countdownTimer(endDate ?? declareDate, setTimeLeft);
        return stopTimer; 
    }, [endDate ?? declareDate]);

    return (
    	<Text
    		variant="title-md"
    		position={ position ?? 'absolute'}
    		fontSize={ fontSize ?? '32px'}
			fontStyle="italic"
			fontWeight="700"
			width={width ?? 'auto'}
			p={ p ?? '0px 16px'}
			m={ m ?? 'unset' }
			borderRadius="100px"
			border={ timeLeft ? `${borderWidth ?? '1px'} solid #2ABDFD` : new Date(declareDate) > new Date() ? `${borderWidth ?? '1px'} solid #ff9500` : `${borderWidth ?? '1px'} solid #FF3B30`}
			background={ timeLeft ? colorDate : new Date(declareDate) > new Date() ? '#ff9500' :  '#FF3B30' }
			top={top ?? '8px'}
			right={right ?? '8px'}
			overflow="hidden"
            bottom={bottom ?? 'unset'}
            textTransform={ timeLeft ? 'unset' : 'uppercase'}
            color={timeLeft ? 'unset' : 'white'}
    		>
    		{ isLine && isDark ? (<Lines
                className="abstract-lines"
                style={{
                  zIndex: 1,
                  left: '0',
                  top: '-100%',
                  transform: 'scale(1.2) rotate(266deg)',
                }} />)
            : isLine && !isDark ?
                (<LinesWhite
                    className="abstract-lines"
                    style={{
                      zIndex: 1,
                      left: '0',
                      top: '-100%',
                      opacity: '0.4',
                      transform: 'scale(1.2) rotate(266deg)',
                    }} />) : ''


            }
    		{timeLeft ? timeLeft : new Date(declareDate) > new Date() ? 'Awaiting Draw' : 'On the Air'}</Text>
   	);
};

export default Countdown;